
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexfq7pL4CF5QAQAUCPr7sH_BkwMtDyQkcQUSZZ1NmK_eIMeta } from "/usr/local/app/apps/uzo.com/app/pages/index.vue?macro=true";
import { default as cartZj1iK6aPskdS1uu98fKpaLNV2ex6utNsIkFIr9UhRekMeta } from "/usr/local/app/apps/uzo.com/app/pages/cart.vue?macro=true";
import { default as searchxO3Anm27QdiHLuyZE_TTcsZWaDjxlpRQ2hpqNlbVFwIMeta } from "/usr/local/app/apps/uzo.com/app/pages/search.vue?macro=true";
import { default as indexbCl5Ld_67K_IjbtT_I7PsxQ_1sVpEijJE7Nx7B_A7p8Meta } from "/usr/local/app/apps/uzo.com/app/pages/account/index.vue?macro=true";
import { default as security_LRyFayVwxvZPYIqrpAcfzreFPrpQN6jWymvHDNjEFgMeta } from "/usr/local/app/apps/uzo.com/app/pages/account/security.vue?macro=true";
import { default as indexx7vwfRU3jK_Rk5rd8gM0tl8cNCRtYUPNvgwLc5aTJ6EMeta } from "/usr/local/app/apps/uzo.com/app/pages/account/orders/index.vue?macro=true";
import { default as _91code_93GXtGt9QGOXHff1_f7GvpZ4mT9IP_ogjcdvtJQZlWMhoMeta } from "/usr/local/app/apps/uzo.com/app/pages/account/orders/[code].vue?macro=true";
import { default as index_hVTsoimLrlFWUVV6_fHRGrv9PJ4SZzk45MZCUJ3qMgMeta } from "/usr/local/app/apps/uzo.com/app/pages/account/addresses/index.vue?macro=true";
import { default as account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta } from "/usr/local/app/apps/uzo.com/app/pages/account.vue?macro=true";
import { default as _91_46_46_46slug_93igxJCAi6i7vEXRKRK0Jj1u9DDXt6NqIAr48Jx3Jk8ngMeta } from "/usr/local/app/apps/uzo.com/app/pages/[...slug].vue?macro=true";
import { default as loginSz_KOcqtSEoZHTy7o4oaISke92q_ubp8hRAWZOrsqdgMeta } from "/usr/local/app/apps/uzo.com/app/pages/auth/login.vue?macro=true";
import { default as logout_ttsTGuyTr_38o8Pqc9D7EDuADW5mYKi34b_0LEmFygMeta } from "/usr/local/app/apps/uzo.com/app/pages/auth/logout.vue?macro=true";
import { default as commitmentsOOIMMuCEyOGmB8MhQFnYptHqW_Hxr2pLHpgR2BSOensMeta } from "/usr/local/app/apps/uzo.com/app/pages/commitments.vue?macro=true";
import { default as registerKl8znFHuvuW_a9pB_OuOkjqJvcFCrxEvMtSUGdmyzlkMeta } from "/usr/local/app/apps/uzo.com/app/pages/auth/register.vue?macro=true";
import { default as indexzE_ugoZCkb_eJtQE9gJR3sEKSRI0RLfg_RHIq1pC3G8Meta } from "/usr/local/app/apps/uzo.com/app/pages/why-uzo/index.vue?macro=true";
import { default as indexkJVfWjIhP9IE4UBezTwfkvr_lMxzgGsp2OQR6EPnxSsMeta } from "/usr/local/app/apps/uzo.com/app/pages/checkout/index.vue?macro=true";
import { default as change_45emailL8d6SAYmabyYOoGP7L_6c5xG3WpdvJhyeI6GsRf_qgMMeta } from "/usr/local/app/apps/uzo.com/app/pages/auth/change-email.vue?macro=true";
import { default as new_45passwordcslr_iGD5qgK_bSTwV5WNQr4pU0Zm0fiRhC4xa8ArXsMeta } from "/usr/local/app/apps/uzo.com/app/pages/auth/new-password.vue?macro=true";
import { default as verify_45emailYZmuYvGrZVEkXkGpOu0sN9vDiuqc_EIxtAOrC00ADtkMeta } from "/usr/local/app/apps/uzo.com/app/pages/auth/verify-email.vue?macro=true";
import { default as indexmIAZZK3RhbO3CxrVNuuxOiHu8ENZAf20i9hcLdAZF5QMeta } from "/usr/local/app/apps/uzo.com/app/pages/track-order/index.vue?macro=true";
import { default as _91slug_93vfBYgzmtGPvl9xZEi6tVT8d6ntG2_8P7k4DP5LuBMsMMeta } from "/usr/local/app/apps/uzo.com/app/pages/stores/[id]/[slug].vue?macro=true";
import { default as _91code_93khp1duPmW2BU2IG_G_XjgOr0nof2Zwr16EVvDHmz7eAMeta } from "/usr/local/app/apps/uzo.com/app/pages/track-order/[code].vue?macro=true";
import { default as reset_45passwordwHCral4jL1Em0j3uOENBaStRIWX7czs7oi2QADr5F3IMeta } from "/usr/local/app/apps/uzo.com/app/pages/auth/reset-password.vue?macro=true";
import { default as _91_91slug_93_93D2mOTlzMqPWpMM1RlWK1cOwp2i8DHeyTX_zu9zudM6UMeta } from "/usr/local/app/apps/uzo.com/app/pages/products/[id]/[[slug]].vue?macro=true";
import { default as best_45sellersW1Iyw302sUEF1DE_SyKuseQdt2XveSW_nTQpPCsjEBgMeta } from "/usr/local/app/apps/uzo.com/app/pages/collections/best-sellers.vue?macro=true";
import { default as new_45arrivalsG5LMgwMZycZnyEit7joh3ouwjS3F_RAG13biAvOerbkMeta } from "/usr/local/app/apps/uzo.com/app/pages/collections/new-arrivals.vue?macro=true";
import { default as top_45for_45less1iCDhzhZhk2U2Uz3d8JYPcVxGLl2TruglQyU486u8EYMeta } from "/usr/local/app/apps/uzo.com/app/pages/collections/top-for-less.vue?macro=true";
import { default as _91_91slug_93_93rXZY5LwpCQCnWaSkqjOowIZzZqUbDcz8WJvmvjs3XyYMeta } from "/usr/local/app/apps/uzo.com/app/pages/collections/[id]/[[slug]].vue?macro=true";
import { default as _91code_93a_Te0oS3lGaM50OZ96oqeoD9fiKyBczkXPzHqAk4V2gMeta } from "/usr/local/app/apps/uzo.com/app/pages/checkout/confirmation/[code].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/index.vue")
  },
  {
    name: "cart___cs",
    path: "/cs/cart",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/cart.vue")
  },
  {
    name: "cart___en",
    path: "/en/cart",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/cart.vue")
  },
  {
    name: "cart___hu",
    path: "/hu/cart",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/cart.vue")
  },
  {
    name: "cart___pl",
    path: "/pl/cart",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/cart.vue")
  },
  {
    name: "cart___ro",
    path: "/ro/cart",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/cart.vue")
  },
  {
    name: "cart___sk",
    path: "/sk/cart",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/cart.vue")
  },
  {
    name: "cart___fr",
    path: "/fr/cart",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/cart.vue")
  },
  {
    name: "cart___es",
    path: "/es/cart",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/cart.vue")
  },
  {
    name: "cart___de",
    path: "/de/cart",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/cart.vue")
  },
  {
    name: "cart___nl",
    path: "/nl/cart",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/cart.vue")
  },
  {
    name: "cart___at",
    path: "/at/cart",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/cart.vue")
  },
  {
    name: "cart___uk",
    path: "/uk/cart",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/cart.vue")
  },
  {
    name: "cart___it",
    path: "/it/cart",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/cart.vue")
  },
  {
    name: "cart___bg",
    path: "/bg/cart",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/cart.vue")
  },
  {
    name: "index___cs",
    path: "/cs",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/index.vue")
  },
  {
    name: "index___hu",
    path: "/hu",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/index.vue")
  },
  {
    name: "index___ro",
    path: "/ro",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/index.vue")
  },
  {
    name: "index___sk",
    path: "/sk",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/index.vue")
  },
  {
    name: "index___at",
    path: "/at",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/index.vue")
  },
  {
    name: "index___uk",
    path: "/uk",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/index.vue")
  },
  {
    name: "index___bg",
    path: "/bg",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/index.vue")
  },
  {
    name: "search___cs",
    path: "/cs/search",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/en/search",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/search.vue")
  },
  {
    name: "search___hu",
    path: "/hu/search",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/search.vue")
  },
  {
    name: "search___pl",
    path: "/pl/search",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/search.vue")
  },
  {
    name: "search___ro",
    path: "/ro/search",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/search.vue")
  },
  {
    name: "search___sk",
    path: "/sk/search",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/search.vue")
  },
  {
    name: "search___fr",
    path: "/fr/search",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/search.vue")
  },
  {
    name: "search___es",
    path: "/es/search",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/search.vue")
  },
  {
    name: "search___de",
    path: "/de/search",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/search.vue")
  },
  {
    name: "search___nl",
    path: "/nl/search",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/search.vue")
  },
  {
    name: "search___at",
    path: "/at/search",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/search.vue")
  },
  {
    name: "search___uk",
    path: "/uk/search",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/search.vue")
  },
  {
    name: "search___it",
    path: "/it/search",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/search.vue")
  },
  {
    name: "search___bg",
    path: "/bg/search",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/search.vue")
  },
  {
    name: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta?.name,
    path: "/cs/account",
    meta: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account.vue"),
    children: [
  {
    name: "account___cs",
    path: "",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/index.vue")
  },
  {
    name: "account-security___cs",
    path: "security",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/security.vue")
  },
  {
    name: "account-orders___cs",
    path: "orders",
    meta: indexx7vwfRU3jK_Rk5rd8gM0tl8cNCRtYUPNvgwLc5aTJ6EMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/index.vue")
  },
  {
    name: "account-orders-code___cs",
    path: "orders/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/[code].vue")
  },
  {
    name: "account-addresses___cs",
    path: "addresses",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/addresses/index.vue")
  }
]
  },
  {
    name: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta?.name,
    path: "/en/account",
    meta: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account.vue"),
    children: [
  {
    name: "account___en",
    path: "",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/index.vue")
  },
  {
    name: "account-security___en",
    path: "security",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/security.vue")
  },
  {
    name: "account-orders___en",
    path: "orders",
    meta: indexx7vwfRU3jK_Rk5rd8gM0tl8cNCRtYUPNvgwLc5aTJ6EMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/index.vue")
  },
  {
    name: "account-orders-code___en",
    path: "orders/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/[code].vue")
  },
  {
    name: "account-addresses___en",
    path: "addresses",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/addresses/index.vue")
  }
]
  },
  {
    name: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta?.name,
    path: "/hu/account",
    meta: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account.vue"),
    children: [
  {
    name: "account___hu",
    path: "",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/index.vue")
  },
  {
    name: "account-security___hu",
    path: "security",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/security.vue")
  },
  {
    name: "account-orders___hu",
    path: "orders",
    meta: indexx7vwfRU3jK_Rk5rd8gM0tl8cNCRtYUPNvgwLc5aTJ6EMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/index.vue")
  },
  {
    name: "account-orders-code___hu",
    path: "orders/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/[code].vue")
  },
  {
    name: "account-addresses___hu",
    path: "addresses",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/addresses/index.vue")
  }
]
  },
  {
    name: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta?.name,
    path: "/pl/account",
    meta: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account.vue"),
    children: [
  {
    name: "account___pl",
    path: "",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/index.vue")
  },
  {
    name: "account-security___pl",
    path: "security",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/security.vue")
  },
  {
    name: "account-orders___pl",
    path: "orders",
    meta: indexx7vwfRU3jK_Rk5rd8gM0tl8cNCRtYUPNvgwLc5aTJ6EMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/index.vue")
  },
  {
    name: "account-orders-code___pl",
    path: "orders/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/[code].vue")
  },
  {
    name: "account-addresses___pl",
    path: "addresses",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/addresses/index.vue")
  }
]
  },
  {
    name: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta?.name,
    path: "/ro/account",
    meta: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account.vue"),
    children: [
  {
    name: "account___ro",
    path: "",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/index.vue")
  },
  {
    name: "account-security___ro",
    path: "security",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/security.vue")
  },
  {
    name: "account-orders___ro",
    path: "orders",
    meta: indexx7vwfRU3jK_Rk5rd8gM0tl8cNCRtYUPNvgwLc5aTJ6EMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/index.vue")
  },
  {
    name: "account-orders-code___ro",
    path: "orders/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/[code].vue")
  },
  {
    name: "account-addresses___ro",
    path: "addresses",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/addresses/index.vue")
  }
]
  },
  {
    name: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta?.name,
    path: "/sk/account",
    meta: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account.vue"),
    children: [
  {
    name: "account___sk",
    path: "",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/index.vue")
  },
  {
    name: "account-security___sk",
    path: "security",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/security.vue")
  },
  {
    name: "account-orders___sk",
    path: "orders",
    meta: indexx7vwfRU3jK_Rk5rd8gM0tl8cNCRtYUPNvgwLc5aTJ6EMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/index.vue")
  },
  {
    name: "account-orders-code___sk",
    path: "orders/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/[code].vue")
  },
  {
    name: "account-addresses___sk",
    path: "addresses",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/addresses/index.vue")
  }
]
  },
  {
    name: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta?.name,
    path: "/fr/account",
    meta: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account.vue"),
    children: [
  {
    name: "account___fr",
    path: "",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/index.vue")
  },
  {
    name: "account-security___fr",
    path: "security",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/security.vue")
  },
  {
    name: "account-orders___fr",
    path: "orders",
    meta: indexx7vwfRU3jK_Rk5rd8gM0tl8cNCRtYUPNvgwLc5aTJ6EMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/index.vue")
  },
  {
    name: "account-orders-code___fr",
    path: "orders/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/[code].vue")
  },
  {
    name: "account-addresses___fr",
    path: "addresses",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/addresses/index.vue")
  }
]
  },
  {
    name: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta?.name,
    path: "/es/account",
    meta: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account.vue"),
    children: [
  {
    name: "account___es",
    path: "",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/index.vue")
  },
  {
    name: "account-security___es",
    path: "security",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/security.vue")
  },
  {
    name: "account-orders___es",
    path: "orders",
    meta: indexx7vwfRU3jK_Rk5rd8gM0tl8cNCRtYUPNvgwLc5aTJ6EMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/index.vue")
  },
  {
    name: "account-orders-code___es",
    path: "orders/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/[code].vue")
  },
  {
    name: "account-addresses___es",
    path: "addresses",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/addresses/index.vue")
  }
]
  },
  {
    name: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta?.name,
    path: "/de/account",
    meta: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account.vue"),
    children: [
  {
    name: "account___de",
    path: "",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/index.vue")
  },
  {
    name: "account-security___de",
    path: "security",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/security.vue")
  },
  {
    name: "account-orders___de",
    path: "orders",
    meta: indexx7vwfRU3jK_Rk5rd8gM0tl8cNCRtYUPNvgwLc5aTJ6EMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/index.vue")
  },
  {
    name: "account-orders-code___de",
    path: "orders/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/[code].vue")
  },
  {
    name: "account-addresses___de",
    path: "addresses",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/addresses/index.vue")
  }
]
  },
  {
    name: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta?.name,
    path: "/nl/account",
    meta: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account.vue"),
    children: [
  {
    name: "account___nl",
    path: "",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/index.vue")
  },
  {
    name: "account-security___nl",
    path: "security",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/security.vue")
  },
  {
    name: "account-orders___nl",
    path: "orders",
    meta: indexx7vwfRU3jK_Rk5rd8gM0tl8cNCRtYUPNvgwLc5aTJ6EMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/index.vue")
  },
  {
    name: "account-orders-code___nl",
    path: "orders/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/[code].vue")
  },
  {
    name: "account-addresses___nl",
    path: "addresses",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/addresses/index.vue")
  }
]
  },
  {
    name: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta?.name,
    path: "/at/account",
    meta: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account.vue"),
    children: [
  {
    name: "account___at",
    path: "",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/index.vue")
  },
  {
    name: "account-security___at",
    path: "security",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/security.vue")
  },
  {
    name: "account-orders___at",
    path: "orders",
    meta: indexx7vwfRU3jK_Rk5rd8gM0tl8cNCRtYUPNvgwLc5aTJ6EMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/index.vue")
  },
  {
    name: "account-orders-code___at",
    path: "orders/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/[code].vue")
  },
  {
    name: "account-addresses___at",
    path: "addresses",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/addresses/index.vue")
  }
]
  },
  {
    name: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta?.name,
    path: "/uk/account",
    meta: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account.vue"),
    children: [
  {
    name: "account___uk",
    path: "",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/index.vue")
  },
  {
    name: "account-security___uk",
    path: "security",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/security.vue")
  },
  {
    name: "account-orders___uk",
    path: "orders",
    meta: indexx7vwfRU3jK_Rk5rd8gM0tl8cNCRtYUPNvgwLc5aTJ6EMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/index.vue")
  },
  {
    name: "account-orders-code___uk",
    path: "orders/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/[code].vue")
  },
  {
    name: "account-addresses___uk",
    path: "addresses",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/addresses/index.vue")
  }
]
  },
  {
    name: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta?.name,
    path: "/it/account",
    meta: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account.vue"),
    children: [
  {
    name: "account___it",
    path: "",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/index.vue")
  },
  {
    name: "account-security___it",
    path: "security",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/security.vue")
  },
  {
    name: "account-orders___it",
    path: "orders",
    meta: indexx7vwfRU3jK_Rk5rd8gM0tl8cNCRtYUPNvgwLc5aTJ6EMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/index.vue")
  },
  {
    name: "account-orders-code___it",
    path: "orders/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/[code].vue")
  },
  {
    name: "account-addresses___it",
    path: "addresses",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/addresses/index.vue")
  }
]
  },
  {
    name: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta?.name,
    path: "/bg/account",
    meta: account0IpnwAGNzSpm4SeJzbYsXWY10Msl17_YGbRLzE7xUegMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account.vue"),
    children: [
  {
    name: "account___bg",
    path: "",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/index.vue")
  },
  {
    name: "account-security___bg",
    path: "security",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/security.vue")
  },
  {
    name: "account-orders___bg",
    path: "orders",
    meta: indexx7vwfRU3jK_Rk5rd8gM0tl8cNCRtYUPNvgwLc5aTJ6EMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/index.vue")
  },
  {
    name: "account-orders-code___bg",
    path: "orders/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/orders/[code].vue")
  },
  {
    name: "account-addresses___bg",
    path: "addresses",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/account/addresses/index.vue")
  }
]
  },
  {
    name: "slug___cs",
    path: "/cs/:slug(.*)*",
    meta: _91_46_46_46slug_93igxJCAi6i7vEXRKRK0Jj1u9DDXt6NqIAr48Jx3Jk8ngMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    meta: _91_46_46_46slug_93igxJCAi6i7vEXRKRK0Jj1u9DDXt6NqIAr48Jx3Jk8ngMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/[...slug].vue")
  },
  {
    name: "slug___hu",
    path: "/hu/:slug(.*)*",
    meta: _91_46_46_46slug_93igxJCAi6i7vEXRKRK0Jj1u9DDXt6NqIAr48Jx3Jk8ngMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/[...slug].vue")
  },
  {
    name: "slug___pl",
    path: "/pl/:slug(.*)*",
    meta: _91_46_46_46slug_93igxJCAi6i7vEXRKRK0Jj1u9DDXt6NqIAr48Jx3Jk8ngMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/[...slug].vue")
  },
  {
    name: "slug___ro",
    path: "/ro/:slug(.*)*",
    meta: _91_46_46_46slug_93igxJCAi6i7vEXRKRK0Jj1u9DDXt6NqIAr48Jx3Jk8ngMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/[...slug].vue")
  },
  {
    name: "slug___sk",
    path: "/sk/:slug(.*)*",
    meta: _91_46_46_46slug_93igxJCAi6i7vEXRKRK0Jj1u9DDXt6NqIAr48Jx3Jk8ngMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    meta: _91_46_46_46slug_93igxJCAi6i7vEXRKRK0Jj1u9DDXt6NqIAr48Jx3Jk8ngMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/[...slug].vue")
  },
  {
    name: "slug___es",
    path: "/es/:slug(.*)*",
    meta: _91_46_46_46slug_93igxJCAi6i7vEXRKRK0Jj1u9DDXt6NqIAr48Jx3Jk8ngMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/[...slug].vue")
  },
  {
    name: "slug___de",
    path: "/de/:slug(.*)*",
    meta: _91_46_46_46slug_93igxJCAi6i7vEXRKRK0Jj1u9DDXt6NqIAr48Jx3Jk8ngMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/[...slug].vue")
  },
  {
    name: "slug___nl",
    path: "/nl/:slug(.*)*",
    meta: _91_46_46_46slug_93igxJCAi6i7vEXRKRK0Jj1u9DDXt6NqIAr48Jx3Jk8ngMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/[...slug].vue")
  },
  {
    name: "slug___at",
    path: "/at/:slug(.*)*",
    meta: _91_46_46_46slug_93igxJCAi6i7vEXRKRK0Jj1u9DDXt6NqIAr48Jx3Jk8ngMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/[...slug].vue")
  },
  {
    name: "slug___uk",
    path: "/uk/:slug(.*)*",
    meta: _91_46_46_46slug_93igxJCAi6i7vEXRKRK0Jj1u9DDXt6NqIAr48Jx3Jk8ngMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/[...slug].vue")
  },
  {
    name: "slug___it",
    path: "/it/:slug(.*)*",
    meta: _91_46_46_46slug_93igxJCAi6i7vEXRKRK0Jj1u9DDXt6NqIAr48Jx3Jk8ngMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/[...slug].vue")
  },
  {
    name: "slug___bg",
    path: "/bg/:slug(.*)*",
    meta: _91_46_46_46slug_93igxJCAi6i7vEXRKRK0Jj1u9DDXt6NqIAr48Jx3Jk8ngMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/[...slug].vue")
  },
  {
    name: "auth-login___cs",
    path: "/cs/auth/login",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___en",
    path: "/en/auth/login",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___hu",
    path: "/hu/auth/login",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___pl",
    path: "/pl/auth/login",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___ro",
    path: "/ro/auth/login",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___sk",
    path: "/sk/auth/login",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___fr",
    path: "/fr/auth/login",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___es",
    path: "/es/auth/login",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___de",
    path: "/de/auth/login",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___nl",
    path: "/nl/auth/login",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___at",
    path: "/at/auth/login",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___uk",
    path: "/uk/auth/login",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___it",
    path: "/it/auth/login",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___bg",
    path: "/bg/auth/login",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/login.vue")
  },
  {
    name: "auth-logout___cs",
    path: "/cs/auth/logout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/logout.vue")
  },
  {
    name: "auth-logout___en",
    path: "/en/auth/logout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/logout.vue")
  },
  {
    name: "auth-logout___hu",
    path: "/hu/auth/logout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/logout.vue")
  },
  {
    name: "auth-logout___pl",
    path: "/pl/auth/logout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/logout.vue")
  },
  {
    name: "auth-logout___ro",
    path: "/ro/auth/logout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/logout.vue")
  },
  {
    name: "auth-logout___sk",
    path: "/sk/auth/logout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/logout.vue")
  },
  {
    name: "auth-logout___fr",
    path: "/fr/auth/logout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/logout.vue")
  },
  {
    name: "auth-logout___es",
    path: "/es/auth/logout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/logout.vue")
  },
  {
    name: "auth-logout___de",
    path: "/de/auth/logout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/logout.vue")
  },
  {
    name: "auth-logout___nl",
    path: "/nl/auth/logout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/logout.vue")
  },
  {
    name: "auth-logout___at",
    path: "/at/auth/logout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/logout.vue")
  },
  {
    name: "auth-logout___uk",
    path: "/uk/auth/logout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/logout.vue")
  },
  {
    name: "auth-logout___it",
    path: "/it/auth/logout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/logout.vue")
  },
  {
    name: "auth-logout___bg",
    path: "/bg/auth/logout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/logout.vue")
  },
  {
    name: "commitments___cs",
    path: "/cs/commitments",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/commitments.vue")
  },
  {
    name: "commitments___en",
    path: "/en/commitments",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/commitments.vue")
  },
  {
    name: "commitments___hu",
    path: "/hu/commitments",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/commitments.vue")
  },
  {
    name: "commitments___pl",
    path: "/pl/commitments",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/commitments.vue")
  },
  {
    name: "commitments___ro",
    path: "/ro/commitments",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/commitments.vue")
  },
  {
    name: "commitments___sk",
    path: "/sk/commitments",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/commitments.vue")
  },
  {
    name: "commitments___fr",
    path: "/fr/commitments",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/commitments.vue")
  },
  {
    name: "commitments___es",
    path: "/es/commitments",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/commitments.vue")
  },
  {
    name: "commitments___de",
    path: "/de/commitments",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/commitments.vue")
  },
  {
    name: "commitments___nl",
    path: "/nl/commitments",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/commitments.vue")
  },
  {
    name: "commitments___at",
    path: "/at/commitments",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/commitments.vue")
  },
  {
    name: "commitments___uk",
    path: "/uk/commitments",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/commitments.vue")
  },
  {
    name: "commitments___it",
    path: "/it/commitments",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/commitments.vue")
  },
  {
    name: "commitments___bg",
    path: "/bg/commitments",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/commitments.vue")
  },
  {
    name: "auth-register___cs",
    path: "/cs/auth/register",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/register.vue")
  },
  {
    name: "auth-register___en",
    path: "/en/auth/register",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/register.vue")
  },
  {
    name: "auth-register___hu",
    path: "/hu/auth/register",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/register.vue")
  },
  {
    name: "auth-register___pl",
    path: "/pl/auth/register",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/register.vue")
  },
  {
    name: "auth-register___ro",
    path: "/ro/auth/register",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/register.vue")
  },
  {
    name: "auth-register___sk",
    path: "/sk/auth/register",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/register.vue")
  },
  {
    name: "auth-register___fr",
    path: "/fr/auth/register",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/register.vue")
  },
  {
    name: "auth-register___es",
    path: "/es/auth/register",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/register.vue")
  },
  {
    name: "auth-register___de",
    path: "/de/auth/register",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/register.vue")
  },
  {
    name: "auth-register___nl",
    path: "/nl/auth/register",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/register.vue")
  },
  {
    name: "auth-register___at",
    path: "/at/auth/register",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/register.vue")
  },
  {
    name: "auth-register___uk",
    path: "/uk/auth/register",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/register.vue")
  },
  {
    name: "auth-register___it",
    path: "/it/auth/register",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/register.vue")
  },
  {
    name: "auth-register___bg",
    path: "/bg/auth/register",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/register.vue")
  },
  {
    name: "why-uzo___cs",
    path: "/cs/why-uzo",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/why-uzo/index.vue")
  },
  {
    name: "why-uzo___en",
    path: "/en/why-uzo",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/why-uzo/index.vue")
  },
  {
    name: "why-uzo___hu",
    path: "/hu/why-uzo",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/why-uzo/index.vue")
  },
  {
    name: "why-uzo___pl",
    path: "/pl/why-uzo",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/why-uzo/index.vue")
  },
  {
    name: "why-uzo___ro",
    path: "/ro/why-uzo",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/why-uzo/index.vue")
  },
  {
    name: "why-uzo___sk",
    path: "/sk/why-uzo",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/why-uzo/index.vue")
  },
  {
    name: "why-uzo___fr",
    path: "/fr/why-uzo",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/why-uzo/index.vue")
  },
  {
    name: "why-uzo___es",
    path: "/es/why-uzo",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/why-uzo/index.vue")
  },
  {
    name: "why-uzo___de",
    path: "/de/why-uzo",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/why-uzo/index.vue")
  },
  {
    name: "why-uzo___nl",
    path: "/nl/why-uzo",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/why-uzo/index.vue")
  },
  {
    name: "why-uzo___at",
    path: "/at/why-uzo",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/why-uzo/index.vue")
  },
  {
    name: "why-uzo___uk",
    path: "/uk/why-uzo",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/why-uzo/index.vue")
  },
  {
    name: "why-uzo___it",
    path: "/it/why-uzo",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/why-uzo/index.vue")
  },
  {
    name: "why-uzo___bg",
    path: "/bg/why-uzo",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/why-uzo/index.vue")
  },
  {
    name: "checkout___cs",
    path: "/cs/checkout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/index.vue")
  },
  {
    name: "checkout___en",
    path: "/en/checkout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/index.vue")
  },
  {
    name: "checkout___hu",
    path: "/hu/checkout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/index.vue")
  },
  {
    name: "checkout___pl",
    path: "/pl/checkout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/index.vue")
  },
  {
    name: "checkout___ro",
    path: "/ro/checkout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/index.vue")
  },
  {
    name: "checkout___sk",
    path: "/sk/checkout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/index.vue")
  },
  {
    name: "checkout___fr",
    path: "/fr/checkout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/index.vue")
  },
  {
    name: "checkout___es",
    path: "/es/checkout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/index.vue")
  },
  {
    name: "checkout___de",
    path: "/de/checkout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/index.vue")
  },
  {
    name: "checkout___nl",
    path: "/nl/checkout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/index.vue")
  },
  {
    name: "checkout___at",
    path: "/at/checkout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/index.vue")
  },
  {
    name: "checkout___uk",
    path: "/uk/checkout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/index.vue")
  },
  {
    name: "checkout___it",
    path: "/it/checkout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/index.vue")
  },
  {
    name: "checkout___bg",
    path: "/bg/checkout",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/index.vue")
  },
  {
    name: "auth-change-email___cs",
    path: "/cs/auth/change-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/change-email.vue")
  },
  {
    name: "auth-change-email___en",
    path: "/en/auth/change-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/change-email.vue")
  },
  {
    name: "auth-change-email___hu",
    path: "/hu/auth/change-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/change-email.vue")
  },
  {
    name: "auth-change-email___pl",
    path: "/pl/auth/change-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/change-email.vue")
  },
  {
    name: "auth-change-email___ro",
    path: "/ro/auth/change-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/change-email.vue")
  },
  {
    name: "auth-change-email___sk",
    path: "/sk/auth/change-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/change-email.vue")
  },
  {
    name: "auth-change-email___fr",
    path: "/fr/auth/change-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/change-email.vue")
  },
  {
    name: "auth-change-email___es",
    path: "/es/auth/change-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/change-email.vue")
  },
  {
    name: "auth-change-email___de",
    path: "/de/auth/change-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/change-email.vue")
  },
  {
    name: "auth-change-email___nl",
    path: "/nl/auth/change-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/change-email.vue")
  },
  {
    name: "auth-change-email___at",
    path: "/at/auth/change-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/change-email.vue")
  },
  {
    name: "auth-change-email___uk",
    path: "/uk/auth/change-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/change-email.vue")
  },
  {
    name: "auth-change-email___it",
    path: "/it/auth/change-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/change-email.vue")
  },
  {
    name: "auth-change-email___bg",
    path: "/bg/auth/change-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/change-email.vue")
  },
  {
    name: "auth-new-password___cs",
    path: "/cs/auth/new-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/new-password.vue")
  },
  {
    name: "auth-new-password___en",
    path: "/en/auth/new-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/new-password.vue")
  },
  {
    name: "auth-new-password___hu",
    path: "/hu/auth/new-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/new-password.vue")
  },
  {
    name: "auth-new-password___pl",
    path: "/pl/auth/new-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/new-password.vue")
  },
  {
    name: "auth-new-password___ro",
    path: "/ro/auth/new-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/new-password.vue")
  },
  {
    name: "auth-new-password___sk",
    path: "/sk/auth/new-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/new-password.vue")
  },
  {
    name: "auth-new-password___fr",
    path: "/fr/auth/new-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/new-password.vue")
  },
  {
    name: "auth-new-password___es",
    path: "/es/auth/new-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/new-password.vue")
  },
  {
    name: "auth-new-password___de",
    path: "/de/auth/new-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/new-password.vue")
  },
  {
    name: "auth-new-password___nl",
    path: "/nl/auth/new-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/new-password.vue")
  },
  {
    name: "auth-new-password___at",
    path: "/at/auth/new-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/new-password.vue")
  },
  {
    name: "auth-new-password___uk",
    path: "/uk/auth/new-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/new-password.vue")
  },
  {
    name: "auth-new-password___it",
    path: "/it/auth/new-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/new-password.vue")
  },
  {
    name: "auth-new-password___bg",
    path: "/bg/auth/new-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/new-password.vue")
  },
  {
    name: "auth-verify-email___cs",
    path: "/cs/auth/verify-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/verify-email.vue")
  },
  {
    name: "auth-verify-email___en",
    path: "/en/auth/verify-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/verify-email.vue")
  },
  {
    name: "auth-verify-email___hu",
    path: "/hu/auth/verify-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/verify-email.vue")
  },
  {
    name: "auth-verify-email___pl",
    path: "/pl/auth/verify-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/verify-email.vue")
  },
  {
    name: "auth-verify-email___ro",
    path: "/ro/auth/verify-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/verify-email.vue")
  },
  {
    name: "auth-verify-email___sk",
    path: "/sk/auth/verify-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/verify-email.vue")
  },
  {
    name: "auth-verify-email___fr",
    path: "/fr/auth/verify-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/verify-email.vue")
  },
  {
    name: "auth-verify-email___es",
    path: "/es/auth/verify-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/verify-email.vue")
  },
  {
    name: "auth-verify-email___de",
    path: "/de/auth/verify-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/verify-email.vue")
  },
  {
    name: "auth-verify-email___nl",
    path: "/nl/auth/verify-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/verify-email.vue")
  },
  {
    name: "auth-verify-email___at",
    path: "/at/auth/verify-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/verify-email.vue")
  },
  {
    name: "auth-verify-email___uk",
    path: "/uk/auth/verify-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/verify-email.vue")
  },
  {
    name: "auth-verify-email___it",
    path: "/it/auth/verify-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/verify-email.vue")
  },
  {
    name: "auth-verify-email___bg",
    path: "/bg/auth/verify-email",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/verify-email.vue")
  },
  {
    name: "track-order___cs",
    path: "/cs/track-order",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/index.vue")
  },
  {
    name: "track-order___en",
    path: "/en/track-order",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/index.vue")
  },
  {
    name: "track-order___hu",
    path: "/hu/track-order",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/index.vue")
  },
  {
    name: "track-order___pl",
    path: "/pl/track-order",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/index.vue")
  },
  {
    name: "track-order___ro",
    path: "/ro/track-order",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/index.vue")
  },
  {
    name: "track-order___sk",
    path: "/sk/track-order",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/index.vue")
  },
  {
    name: "track-order___fr",
    path: "/fr/track-order",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/index.vue")
  },
  {
    name: "track-order___es",
    path: "/es/track-order",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/index.vue")
  },
  {
    name: "track-order___de",
    path: "/de/track-order",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/index.vue")
  },
  {
    name: "track-order___nl",
    path: "/nl/track-order",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/index.vue")
  },
  {
    name: "track-order___at",
    path: "/at/track-order",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/index.vue")
  },
  {
    name: "track-order___uk",
    path: "/uk/track-order",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/index.vue")
  },
  {
    name: "track-order___it",
    path: "/it/track-order",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/index.vue")
  },
  {
    name: "track-order___bg",
    path: "/bg/track-order",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/index.vue")
  },
  {
    name: "stores-id-slug___cs",
    path: "/cs/stores/:id()/:slug()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/stores/[id]/[slug].vue")
  },
  {
    name: "stores-id-slug___en",
    path: "/en/stores/:id()/:slug()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/stores/[id]/[slug].vue")
  },
  {
    name: "stores-id-slug___hu",
    path: "/hu/stores/:id()/:slug()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/stores/[id]/[slug].vue")
  },
  {
    name: "stores-id-slug___pl",
    path: "/pl/stores/:id()/:slug()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/stores/[id]/[slug].vue")
  },
  {
    name: "stores-id-slug___ro",
    path: "/ro/stores/:id()/:slug()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/stores/[id]/[slug].vue")
  },
  {
    name: "stores-id-slug___sk",
    path: "/sk/stores/:id()/:slug()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/stores/[id]/[slug].vue")
  },
  {
    name: "stores-id-slug___fr",
    path: "/fr/stores/:id()/:slug()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/stores/[id]/[slug].vue")
  },
  {
    name: "stores-id-slug___es",
    path: "/es/stores/:id()/:slug()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/stores/[id]/[slug].vue")
  },
  {
    name: "stores-id-slug___de",
    path: "/de/stores/:id()/:slug()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/stores/[id]/[slug].vue")
  },
  {
    name: "stores-id-slug___nl",
    path: "/nl/stores/:id()/:slug()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/stores/[id]/[slug].vue")
  },
  {
    name: "stores-id-slug___at",
    path: "/at/stores/:id()/:slug()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/stores/[id]/[slug].vue")
  },
  {
    name: "stores-id-slug___uk",
    path: "/uk/stores/:id()/:slug()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/stores/[id]/[slug].vue")
  },
  {
    name: "stores-id-slug___it",
    path: "/it/stores/:id()/:slug()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/stores/[id]/[slug].vue")
  },
  {
    name: "stores-id-slug___bg",
    path: "/bg/stores/:id()/:slug()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/stores/[id]/[slug].vue")
  },
  {
    name: "track-order-code___cs",
    path: "/cs/track-order/:code()",
    meta: _91code_93khp1duPmW2BU2IG_G_XjgOr0nof2Zwr16EVvDHmz7eAMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/[code].vue")
  },
  {
    name: "track-order-code___en",
    path: "/en/track-order/:code()",
    meta: _91code_93khp1duPmW2BU2IG_G_XjgOr0nof2Zwr16EVvDHmz7eAMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/[code].vue")
  },
  {
    name: "track-order-code___hu",
    path: "/hu/track-order/:code()",
    meta: _91code_93khp1duPmW2BU2IG_G_XjgOr0nof2Zwr16EVvDHmz7eAMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/[code].vue")
  },
  {
    name: "track-order-code___pl",
    path: "/pl/track-order/:code()",
    meta: _91code_93khp1duPmW2BU2IG_G_XjgOr0nof2Zwr16EVvDHmz7eAMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/[code].vue")
  },
  {
    name: "track-order-code___ro",
    path: "/ro/track-order/:code()",
    meta: _91code_93khp1duPmW2BU2IG_G_XjgOr0nof2Zwr16EVvDHmz7eAMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/[code].vue")
  },
  {
    name: "track-order-code___sk",
    path: "/sk/track-order/:code()",
    meta: _91code_93khp1duPmW2BU2IG_G_XjgOr0nof2Zwr16EVvDHmz7eAMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/[code].vue")
  },
  {
    name: "track-order-code___fr",
    path: "/fr/track-order/:code()",
    meta: _91code_93khp1duPmW2BU2IG_G_XjgOr0nof2Zwr16EVvDHmz7eAMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/[code].vue")
  },
  {
    name: "track-order-code___es",
    path: "/es/track-order/:code()",
    meta: _91code_93khp1duPmW2BU2IG_G_XjgOr0nof2Zwr16EVvDHmz7eAMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/[code].vue")
  },
  {
    name: "track-order-code___de",
    path: "/de/track-order/:code()",
    meta: _91code_93khp1duPmW2BU2IG_G_XjgOr0nof2Zwr16EVvDHmz7eAMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/[code].vue")
  },
  {
    name: "track-order-code___nl",
    path: "/nl/track-order/:code()",
    meta: _91code_93khp1duPmW2BU2IG_G_XjgOr0nof2Zwr16EVvDHmz7eAMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/[code].vue")
  },
  {
    name: "track-order-code___at",
    path: "/at/track-order/:code()",
    meta: _91code_93khp1duPmW2BU2IG_G_XjgOr0nof2Zwr16EVvDHmz7eAMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/[code].vue")
  },
  {
    name: "track-order-code___uk",
    path: "/uk/track-order/:code()",
    meta: _91code_93khp1duPmW2BU2IG_G_XjgOr0nof2Zwr16EVvDHmz7eAMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/[code].vue")
  },
  {
    name: "track-order-code___it",
    path: "/it/track-order/:code()",
    meta: _91code_93khp1duPmW2BU2IG_G_XjgOr0nof2Zwr16EVvDHmz7eAMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/[code].vue")
  },
  {
    name: "track-order-code___bg",
    path: "/bg/track-order/:code()",
    meta: _91code_93khp1duPmW2BU2IG_G_XjgOr0nof2Zwr16EVvDHmz7eAMeta || {},
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/track-order/[code].vue")
  },
  {
    name: "auth-reset-password___cs",
    path: "/cs/auth/reset-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___en",
    path: "/en/auth/reset-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___hu",
    path: "/hu/auth/reset-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___pl",
    path: "/pl/auth/reset-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___ro",
    path: "/ro/auth/reset-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___sk",
    path: "/sk/auth/reset-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___fr",
    path: "/fr/auth/reset-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___es",
    path: "/es/auth/reset-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___de",
    path: "/de/auth/reset-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___nl",
    path: "/nl/auth/reset-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___at",
    path: "/at/auth/reset-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___uk",
    path: "/uk/auth/reset-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___it",
    path: "/it/auth/reset-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___bg",
    path: "/bg/auth/reset-password",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/auth/reset-password.vue")
  },
  {
    name: "products-id-slug___cs",
    path: "/cs/products/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/products/[id]/[[slug]].vue")
  },
  {
    name: "products-id-slug___en",
    path: "/en/products/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/products/[id]/[[slug]].vue")
  },
  {
    name: "products-id-slug___hu",
    path: "/hu/products/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/products/[id]/[[slug]].vue")
  },
  {
    name: "products-id-slug___pl",
    path: "/pl/products/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/products/[id]/[[slug]].vue")
  },
  {
    name: "products-id-slug___ro",
    path: "/ro/products/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/products/[id]/[[slug]].vue")
  },
  {
    name: "products-id-slug___sk",
    path: "/sk/products/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/products/[id]/[[slug]].vue")
  },
  {
    name: "products-id-slug___fr",
    path: "/fr/products/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/products/[id]/[[slug]].vue")
  },
  {
    name: "products-id-slug___es",
    path: "/es/products/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/products/[id]/[[slug]].vue")
  },
  {
    name: "products-id-slug___de",
    path: "/de/products/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/products/[id]/[[slug]].vue")
  },
  {
    name: "products-id-slug___nl",
    path: "/nl/products/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/products/[id]/[[slug]].vue")
  },
  {
    name: "products-id-slug___at",
    path: "/at/products/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/products/[id]/[[slug]].vue")
  },
  {
    name: "products-id-slug___uk",
    path: "/uk/products/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/products/[id]/[[slug]].vue")
  },
  {
    name: "products-id-slug___it",
    path: "/it/products/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/products/[id]/[[slug]].vue")
  },
  {
    name: "products-id-slug___bg",
    path: "/bg/products/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/products/[id]/[[slug]].vue")
  },
  {
    name: "collections-best-sellers___cs",
    path: "/cs/collections/best-sellers",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/best-sellers.vue")
  },
  {
    name: "collections-best-sellers___en",
    path: "/en/collections/best-sellers",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/best-sellers.vue")
  },
  {
    name: "collections-best-sellers___hu",
    path: "/hu/collections/best-sellers",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/best-sellers.vue")
  },
  {
    name: "collections-best-sellers___pl",
    path: "/pl/collections/best-sellers",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/best-sellers.vue")
  },
  {
    name: "collections-best-sellers___ro",
    path: "/ro/collections/best-sellers",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/best-sellers.vue")
  },
  {
    name: "collections-best-sellers___sk",
    path: "/sk/collections/best-sellers",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/best-sellers.vue")
  },
  {
    name: "collections-best-sellers___fr",
    path: "/fr/collections/best-sellers",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/best-sellers.vue")
  },
  {
    name: "collections-best-sellers___es",
    path: "/es/collections/best-sellers",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/best-sellers.vue")
  },
  {
    name: "collections-best-sellers___de",
    path: "/de/collections/best-sellers",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/best-sellers.vue")
  },
  {
    name: "collections-best-sellers___nl",
    path: "/nl/collections/best-sellers",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/best-sellers.vue")
  },
  {
    name: "collections-best-sellers___at",
    path: "/at/collections/best-sellers",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/best-sellers.vue")
  },
  {
    name: "collections-best-sellers___uk",
    path: "/uk/collections/best-sellers",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/best-sellers.vue")
  },
  {
    name: "collections-best-sellers___it",
    path: "/it/collections/best-sellers",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/best-sellers.vue")
  },
  {
    name: "collections-best-sellers___bg",
    path: "/bg/collections/best-sellers",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/best-sellers.vue")
  },
  {
    name: "collections-new-arrivals___cs",
    path: "/cs/collections/new-arrivals",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/new-arrivals.vue")
  },
  {
    name: "collections-new-arrivals___en",
    path: "/en/collections/new-arrivals",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/new-arrivals.vue")
  },
  {
    name: "collections-new-arrivals___hu",
    path: "/hu/collections/new-arrivals",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/new-arrivals.vue")
  },
  {
    name: "collections-new-arrivals___pl",
    path: "/pl/collections/new-arrivals",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/new-arrivals.vue")
  },
  {
    name: "collections-new-arrivals___ro",
    path: "/ro/collections/new-arrivals",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/new-arrivals.vue")
  },
  {
    name: "collections-new-arrivals___sk",
    path: "/sk/collections/new-arrivals",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/new-arrivals.vue")
  },
  {
    name: "collections-new-arrivals___fr",
    path: "/fr/collections/new-arrivals",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/new-arrivals.vue")
  },
  {
    name: "collections-new-arrivals___es",
    path: "/es/collections/new-arrivals",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/new-arrivals.vue")
  },
  {
    name: "collections-new-arrivals___de",
    path: "/de/collections/new-arrivals",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/new-arrivals.vue")
  },
  {
    name: "collections-new-arrivals___nl",
    path: "/nl/collections/new-arrivals",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/new-arrivals.vue")
  },
  {
    name: "collections-new-arrivals___at",
    path: "/at/collections/new-arrivals",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/new-arrivals.vue")
  },
  {
    name: "collections-new-arrivals___uk",
    path: "/uk/collections/new-arrivals",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/new-arrivals.vue")
  },
  {
    name: "collections-new-arrivals___it",
    path: "/it/collections/new-arrivals",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/new-arrivals.vue")
  },
  {
    name: "collections-new-arrivals___bg",
    path: "/bg/collections/new-arrivals",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/new-arrivals.vue")
  },
  {
    name: "collections-top-for-less___cs",
    path: "/cs/collections/top-for-less",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/top-for-less.vue")
  },
  {
    name: "collections-top-for-less___en",
    path: "/en/collections/top-for-less",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/top-for-less.vue")
  },
  {
    name: "collections-top-for-less___hu",
    path: "/hu/collections/top-for-less",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/top-for-less.vue")
  },
  {
    name: "collections-top-for-less___pl",
    path: "/pl/collections/top-for-less",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/top-for-less.vue")
  },
  {
    name: "collections-top-for-less___ro",
    path: "/ro/collections/top-for-less",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/top-for-less.vue")
  },
  {
    name: "collections-top-for-less___sk",
    path: "/sk/collections/top-for-less",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/top-for-less.vue")
  },
  {
    name: "collections-top-for-less___fr",
    path: "/fr/collections/top-for-less",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/top-for-less.vue")
  },
  {
    name: "collections-top-for-less___es",
    path: "/es/collections/top-for-less",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/top-for-less.vue")
  },
  {
    name: "collections-top-for-less___de",
    path: "/de/collections/top-for-less",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/top-for-less.vue")
  },
  {
    name: "collections-top-for-less___nl",
    path: "/nl/collections/top-for-less",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/top-for-less.vue")
  },
  {
    name: "collections-top-for-less___at",
    path: "/at/collections/top-for-less",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/top-for-less.vue")
  },
  {
    name: "collections-top-for-less___uk",
    path: "/uk/collections/top-for-less",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/top-for-less.vue")
  },
  {
    name: "collections-top-for-less___it",
    path: "/it/collections/top-for-less",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/top-for-less.vue")
  },
  {
    name: "collections-top-for-less___bg",
    path: "/bg/collections/top-for-less",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/top-for-less.vue")
  },
  {
    name: "collections-id-slug___cs",
    path: "/cs/collections/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/[id]/[[slug]].vue")
  },
  {
    name: "collections-id-slug___en",
    path: "/en/collections/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/[id]/[[slug]].vue")
  },
  {
    name: "collections-id-slug___hu",
    path: "/hu/collections/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/[id]/[[slug]].vue")
  },
  {
    name: "collections-id-slug___pl",
    path: "/pl/collections/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/[id]/[[slug]].vue")
  },
  {
    name: "collections-id-slug___ro",
    path: "/ro/collections/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/[id]/[[slug]].vue")
  },
  {
    name: "collections-id-slug___sk",
    path: "/sk/collections/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/[id]/[[slug]].vue")
  },
  {
    name: "collections-id-slug___fr",
    path: "/fr/collections/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/[id]/[[slug]].vue")
  },
  {
    name: "collections-id-slug___es",
    path: "/es/collections/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/[id]/[[slug]].vue")
  },
  {
    name: "collections-id-slug___de",
    path: "/de/collections/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/[id]/[[slug]].vue")
  },
  {
    name: "collections-id-slug___nl",
    path: "/nl/collections/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/[id]/[[slug]].vue")
  },
  {
    name: "collections-id-slug___at",
    path: "/at/collections/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/[id]/[[slug]].vue")
  },
  {
    name: "collections-id-slug___uk",
    path: "/uk/collections/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/[id]/[[slug]].vue")
  },
  {
    name: "collections-id-slug___it",
    path: "/it/collections/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/[id]/[[slug]].vue")
  },
  {
    name: "collections-id-slug___bg",
    path: "/bg/collections/:id()/:slug?",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/collections/[id]/[[slug]].vue")
  },
  {
    name: "checkout-confirmation-code___cs",
    path: "/cs/checkout/confirmation/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/confirmation/[code].vue")
  },
  {
    name: "checkout-confirmation-code___en",
    path: "/en/checkout/confirmation/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/confirmation/[code].vue")
  },
  {
    name: "checkout-confirmation-code___hu",
    path: "/hu/checkout/confirmation/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/confirmation/[code].vue")
  },
  {
    name: "checkout-confirmation-code___pl",
    path: "/pl/checkout/confirmation/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/confirmation/[code].vue")
  },
  {
    name: "checkout-confirmation-code___ro",
    path: "/ro/checkout/confirmation/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/confirmation/[code].vue")
  },
  {
    name: "checkout-confirmation-code___sk",
    path: "/sk/checkout/confirmation/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/confirmation/[code].vue")
  },
  {
    name: "checkout-confirmation-code___fr",
    path: "/fr/checkout/confirmation/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/confirmation/[code].vue")
  },
  {
    name: "checkout-confirmation-code___es",
    path: "/es/checkout/confirmation/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/confirmation/[code].vue")
  },
  {
    name: "checkout-confirmation-code___de",
    path: "/de/checkout/confirmation/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/confirmation/[code].vue")
  },
  {
    name: "checkout-confirmation-code___nl",
    path: "/nl/checkout/confirmation/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/confirmation/[code].vue")
  },
  {
    name: "checkout-confirmation-code___at",
    path: "/at/checkout/confirmation/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/confirmation/[code].vue")
  },
  {
    name: "checkout-confirmation-code___uk",
    path: "/uk/checkout/confirmation/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/confirmation/[code].vue")
  },
  {
    name: "checkout-confirmation-code___it",
    path: "/it/checkout/confirmation/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/confirmation/[code].vue")
  },
  {
    name: "checkout-confirmation-code___bg",
    path: "/bg/checkout/confirmation/:code()",
    component: () => import("/usr/local/app/apps/uzo.com/app/pages/checkout/confirmation/[code].vue")
  }
]